import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private userServie: UserService
    ) { }

    canActivate(route: ActivatedRouteSnapshot) {
        let user = JSON.parse(localStorage.getItem('user'))
        if (user) {
            return this.userServie.getSessionInfo(user.session_token).then((res) => {
                console.log(res)
                return true;
            }, (err) => {
                // Session not valid redirect to login
                console.log(err);
                this.router.navigate(['/login-page']);
                return false;
            })
        } else {
            // not logged in so redirect to login
            console.log("no user found, going to login screen...");
            this.router.navigate(['/login-page']);
            return false;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts